/* eslint-disable @typescript-eslint/no-explicit-any */
import { EAdmissionStages, IAdmissionStagesResponse } from '@src/constants/modals/admissions';
import { NodeType } from '@src/store/AdmissionStagesStore';
import languageKeys from "@src/localization/local.json";
import { FieldNamesMarkedBoolean, FieldValues } from 'react-hook-form';
import { ERolename } from '@src/constants/modals/auth';




export const getDescription = (step: IAdmissionStagesResponse, t: any) => {
  switch (step?.stage === 'statement_purpose' as any ? 'applications' : step?.stage) {
    case EAdmissionStages.criteria_selection:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.payment:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.basic_details:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.educational_details:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.experience_professional:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.applications:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.upload_documents:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    default:
      break;
  }
};
export const getStatus = (currentStatus: boolean, status: number, optional: number): string => {

  if (currentStatus && status == 0) {
    return 'process';
  } else if (status === 1 || optional === 1) {
    return 'finish';
  } else {
    return 'wait';
  }
};
export const getDisabled = (
  step: IAdmissionStagesResponse,
  admissionStagesResponse: any,
  isUserDetailsEditable: boolean,
  userRole:string | undefined
) => {

  const selectionStage = admissionStagesResponse?.data?.find((s: any) => s.stage === EAdmissionStages.criteria_selection);
  const isCriteriaComplete = selectionStage?.status === 1;
  const paymentStage = admissionStagesResponse?.data?.find((s: any) => s.stage === EAdmissionStages.payment);
  const isPaymentComplete = paymentStage?.status === 1;
  const stagesTobeDisabled = [1,2,3,4,5].includes(step?.order);

  if ((userRole === ERolename?.admin || userRole === ERolename?.dl_admin) && [1,2].includes(step?.order))
    return true;


  if(userRole === ERolename?.department_admin)
    return true;

  if (!isUserDetailsEditable && stagesTobeDisabled && (userRole === ERolename?.user || userRole === ERolename?.test_user)) {
    return true;
  }

  if (!isCriteriaComplete) {
    return true;
  }
  if (isCriteriaComplete && !isPaymentComplete) {
    return step.stage !== EAdmissionStages.payment;
  }
  return step.order <= paymentStage.order;
};


export const getCurrentStepIndex = (steps: Array<any>): number => {
  if (steps.length) {
    const firstIncompleteIndex = steps?.findIndex(({ status, optional }) => status === 0 && optional === 0);
    return firstIncompleteIndex === -1 ? steps.length - 1 : firstIncompleteIndex;
  } else {
    return -1
  }

};
const keys = [
  "personalDetails",
  "markSheet10",
  "markSheet12",
  "graduationCertificate",
  "graduationMarksheet",
  "resume",
  "experienceLetter",
  "extra_document",
  'passportSizePhoto',
  'postGraduationMarksheet',
  'postGraduationCertificate',
  'categoryCertificate'
];

function mapByEntityType(keys: any, items: any) {
  const mapped = keys.reduce((acc: any, key: any) => {
    acc[key] = [];
    return acc;
  }, {});

  items?.forEach((item: any) => {
    if (mapped?.hasOwnProperty(item.entityType)) {
      mapped[item.entityType].push(item);
    }
  });

  return mapped;
}


const defalutValues: { [key: number]: any } = {
  0: { fullName: "", email: "", programId: '', phone: "", countryCode: '+91' },
  1: { correspondencehouseno: '', correspondencepincode: '', correspondencecity: '', correspondencedistrict: '', correspondencestate: '', correspondencecountry: '' },
  2: {
    personal_details: {
      dob: "",
      gender: "",
      nationality: "",
      identityNumber: "",
      category: "",
      dap: null,
      ageGroup: null,
      parentName: null,
      apaarId: null,
      linkedinProfile: null,
      knowAboutProgram: "",
      totalWorkExperience: null,
      highestQualification: "",
      academicMetricType: "",
      academicMetricValue: null,
      examType: null,
      score: null,
      year: null,
      studentTypeIds: [],
    },
    user_address: [
      {
        address: "",
        pincode: "",
        city: "",
        district: null,
        state: "",
        country: "",
        addressType: "correspondence",
      },
      {
        address: "",
        pincode: "",
        city: "",
        district: null,
        state: "",
        country: "",
        addressType: "permanent",
      },
    ],
  },
  3: {
    school_education: [
      {
        standard: "10th",
        year: null,
        totalMarks: null,
        marksObtained: null,
        percentage: null,
        cpi: null,
      },
      {
        standard: "12th",
        year: null,
        totalMarks: null,
        marksObtained: null,
        percentage: null,
        cpi: null,
      },
    ],
    graduation: {
      degree: "",
      discipline: "",
      universityName: null,
      instituteName: null,
      year: null,
      marks: null,
      degreeLevel: "undergraduate"
    },
    post_graduation: [],
    users_research_publication: [],
  },
  4: {
    experience_professional: [{ organization: null, designation: null, role: null, payPerAnnum: null, from: null, to: null, employmentStatus: null, organizationType: null, natureOfOccupation: null, occupationalField: null }],
  },
  5: {
    statement_purpose: {
      statement: null,
    },
  },
  6: {
    personalDetails: [], markSheet10: [], markSheet12: [], graduationCertificate: [], graduationMarksheet: [],
    resume: [], experienceLetter: [], extra_document: [], passportSizePhoto: [], postGraduationCertificate: [], postGraduationMarksheet: [], categoryCertificate: []
  },
};

export const responseModified = (stepIndex: number, value: any) => {
  const defaultStepValues = defalutValues[stepIndex] || {};

  // If value is null or undefined, return the default values
  if (!value || Object.keys(value).length === 0) {
    return defaultStepValues;
  }

  // Merge default values with the provided value
  const mergedValues = { ...defaultStepValues };

  Object.keys(defaultStepValues)?.forEach((key) => {
    if (Array.isArray(defaultStepValues[key])) {
      // If the key is an array and the value is empty or undefined, set the default array
      mergedValues[key] = value[key]?.length ? value[key] : defaultStepValues[key];
    } else {
      // If the key is null or undefined, set the default value
      mergedValues[key] = value[key] ?? defaultStepValues[key];
    }
  });

  if (stepIndex < 6) {
    return mergedValues;
  } else {
    return mapByEntityType(keys, value);
  }
};


export const transformData = (data: any) => {
  const transformed: any = { programId: data.programId };

  Object.keys(data)?.forEach((key) => {
    if (key !== "programId") {
      transformed[key] = [{ fieldName: key, value: data[key] }];
    }
  });

  return transformed;
};

export const sortBySequenceRecursive = (items: any) => {
  return items
    .slice()
    .sort((a: any, b: any) => a.sequence - b.sequence)
    .map((item: any) => ({
      ...item,
      children: item.children && item.children.length
        ? sortBySequenceRecursive(item.children)
        : []
    }));
}



export type InputNode = {
  id: number;
  name: string;
  type: string;
  parent_id: number | null;
  children: InputNode[];
}

type OutputNode = {
  title: string;
  value: string;
  isLeaf: boolean;
  selectable: boolean;
  children?: OutputNode[];
}

export const transformTree = (data: NodeType[]): OutputNode[] => {
  return data.map((node): OutputNode => {
    const hasChildren = node.children && node.children.length > 0;

    return {
      title: node.name,
      value: String(node.id),
      isLeaf: !hasChildren,
      selectable: !hasChildren,
      children: hasChildren ? transformTree(node.children) : []
    };
  });
}

export const transformStatusListTree = (
  data: any,
  currentStatusId: any
) => {

  let currentSequence = 0;

  // Find effective sequence
  data?.forEach((parent:any) => {

    // Parent selected
    if (parent.id === currentStatusId) {
      currentSequence = parent.sequence;
    }

    // Child selected → use parent sequence
    parent.children?.forEach((child: any) => {
      if (child.id === currentStatusId) {
        currentSequence = parent.sequence;
      }
    });

  });

  // Build tree
  return data?.map((node:any) => {

    const hasChildren = node.children?.length > 0;

    const parentDisabled = node.sequence <= currentSequence;

    return {
      title: node.name,
      value: node.id,
      isLeaf: !hasChildren,
      selectable: !parentDisabled && !hasChildren,
      disabled: parentDisabled,

      // Children follow parent state
      children: hasChildren
        ? node.children.map((child: any) => ({
          title: child.name,
          value: child.id,
          isLeaf: true,
          selectable: !parentDisabled,
          disabled: parentDisabled
        }))
        : []
    };
  });
};





export const activeStatusesList = (items: any[]): any[] => {
  return items
    .filter(item => item.active === 1)
    .map(item => ({
      ...item,
      children: item.children?.length
        ? activeStatusesList(item.children)
        : []
    }));
};

export const statusFlatMap = (
  items: any[],
  map: Record<number, string> = {},
  mapNameToId: Record<string, number> = {}
): any => {
  items?.forEach(item => {
    map[item.id] = item.name;
    mapNameToId[item.name] = item.id
    if (item.children?.length) {
      delete map[item.id];
      delete mapNameToId[item.name]
      statusFlatMap(item.children, map, mapNameToId);
    }
  });

  return { map, mapNameToId };
};



export const formatTimestamp = (
  timestamp: number,
  formatType: "shortDate" | "longDate" | "shortDay" | "longDay" | "dateDay" | "iso" | "usDate" | "timeDate"
): string => {
  const date = new Date(
    timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
  );

  const options: Record<string, Intl.DateTimeFormatOptions> = {
    shortDate: { day: "2-digit", month: "2-digit", year: "numeric" },
    longDate: { day: "numeric", month: "long", year: "numeric" },
    shortDay: { weekday: "short" },
    longDay: { weekday: "long" },
    dateDay: { weekday: "long", day: "numeric", month: "long", year: "numeric" },
    iso: { year: "numeric", month: "2-digit", day: "2-digit" },
    usDate: { month: "2-digit", day: "2-digit", year: "numeric" },
    timeDate: { hour: "2-digit", minute: "2-digit", hour12: true, day: "numeric", month: "long", year: "numeric" }
  };

  const formatter = new Intl.DateTimeFormat("en-US", options[formatType]);
  return formatter.format(date);
}

export const courseProgramFlatMap = (arr: NodeType[]): Record<number, string> => {
  let map: Record<number, string> = {};

  for (const item of arr) {
    if (item.parent_id !== null) {
      map[item.id] = item.name;
    }
    if (item.children && item.children.length > 0) {
      const childMap = courseProgramFlatMap(item.children);
      map = { ...map, ...childMap };
    }
  }

  return map;
};


export function getDirtyValues<T extends FieldValues>(
  dirtyFields: FieldNamesMarkedBoolean<T>,
  allValues: T,
  originalValues?: T
): Partial<T> {

  // ---------------------
  // Handle ARRAY (useFieldArray)
  // ---------------------
  if (Array.isArray(allValues)) {
  const result: any[] = [];

  Object.keys(dirtyFields || {})?.forEach((key) => {
    const index = Number(key);

    const dirty = (dirtyFields as any)[key];
    const value = (allValues as any)?.[index];
    const originalValue = originalValues ? (originalValues as any)?.[index] : undefined;

    if (value === undefined) return;

    // ✅ Deleted (always include)
    if (value?.deleted) {
      result.push({ id: value.id, deleted: true });
      return;
    }

    // ✅ New row (no id)
    if (!value?.id) {
      if (!isEmpty(value)) {
        result.push(value);
      }
      return;
    }

    // ✅ Fully dirty
    if (dirty === true) {
      result.push(value);
      return;
    }

    // ✅ Nested dirty
    if (typeof dirty === "object" && dirty !== null) {
      const nested = getDirtyValues(dirty, value, originalValue);

      if (!isEmpty(nested)) {
        nested.id = value.id;
        result.push(nested);
      }
    }
  });

  return result as any;
}


  // ---------------------
  // Handle OBJECT
  // ---------------------
  const dirtyValues: Partial<T> = {};

  Object.keys(dirtyFields || {})?.forEach((key) => {
    const dirty = (dirtyFields as any)[key];
    const value = (allValues as any)[key];

    // Case 3: Include null values when field is cleared
    if (dirty === true) {
      // Include the value even if it's null (cleared field)
      dirtyValues[key as keyof T] = value === "" ? null : value;
      return;
    }

    if (typeof dirty === "object" && dirty !== null) {
      const originalValue = originalValues ? (originalValues as any)?.[key] : undefined;
      const nested = getDirtyValues(dirty, value, originalValue);

      if (!isEmpty(nested)) {
        dirtyValues[key as keyof T] = nested as any;
      }
    }
  });

  // ---------------------
  // Auto include ID (edit mode)
  // ---------------------
  if (
    typeof allValues === "object" &&
    allValues !== null &&
    "id" in allValues &&
    (allValues as any).id !== undefined
  ) {
    (dirtyValues as any).id = (allValues as any)?.id;
  }

  return dirtyValues;
}

// ---------------------
// Utility: Remove empty objects / arrays
// ---------------------
function isEmpty(value: any) {
  if (!value) return true;

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === "object") {
    return Object.keys(value).length === 0;
  }

  return false;
}

export function removeUnwantedKeys<T>(obj: T, REMOVE_KEYS: string[]): T {

  if (Array.isArray(obj)) {
    return obj?.map((item) =>
      removeUnwantedKeys(item, REMOVE_KEYS)
    ) as any;
  }

  if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc: any, key) => {

      if (!REMOVE_KEYS.includes(key)) {
        acc[key] = removeUnwantedKeys(
          (obj as any)[key],
          REMOVE_KEYS
        );
      }

      return acc;
    }, {});
  }

  return obj;
}

export const canEditApplication = (
  role: any,
  applicationStatus: any,
  getFlatMapStatusListNameToId:any,
) => {

  if (role === ERolename?.admin || role === ERolename?.dl_admin) return true;


  if (role === ERolename?.user || role === ERolename?.test_user) {
     return applicationStatus < getFlatMapStatusListNameToId['Application Submitted'];
  }

  return false;
};

export const isApplicationNumberEnable = (applicationStatus:any, role:any)=>{
  if(role === ERolename?.user || role === ERolename?.test_user){
    return [2].includes(applicationStatus)
  }

  return false;

}

export const isUploadFilesDisabled = ( role:any ) =>{
  if(role === ERolename?.admin){
    return false;
  }

  return false;
}

export const transformSchoolEducation = (data: any, values: any) => {
  return data.map((item: any, index: number) => {
    const metric = values?.school_education?.[index]?.metric;

    let percentage = item.percentage ?? null;
    let cpi = item.cpi ?? null;

    if (metric === "percentage") {
      cpi = percentage != null ? Number(percentage) / 10 : null;
    }

    if (metric === "cpi") {
      percentage = cpi != null ? Number(cpi) * 10 : null;
    }

    return {
      id: item.id, // keep only required fields
      percentage,
      cpi,
      standard: item.standard,
      year: item.year ? Number(item.year) : null,
    };
  });
};

export const buildStatusSequenceMap = (items: any[]): Record<number, number> => {
    const map: Record<number, number> = {};
    items.forEach(item => {
        map[item.id] = item.sequence;
        item.children?.forEach((child: any) => {
            map[child.id] = item.sequence; // inherit parent sequence
        });
    });
    return map;
};

export const isExtraDocumentUploadEnabled = (
    role: string | undefined,
    applicationStatus: number,
    sequenceMap: Record<number, number>
): boolean => {
    if (role === ERolename.admin || role === ERolename.dl_admin) return true;
    const vafbooaSequence = 5; // "Verified And Forwarded By OOA" sequence is stable
    const effectiveSeq = sequenceMap[applicationStatus] ?? 0;
    return effectiveSeq < vafbooaSequence;
};